export type TranslationEntry = string;

class Translations {
  private translations: Record<string, TranslationEntry>;
  private static instance: Translations;

  private constructor() {
    this.translations = {};
  }

  static getInstance(): Translations {
    if (!Translations.instance) {
      Translations.instance = new Translations();
    }
    return Translations.instance;
  }

  addToDictionary(key: string, translation: TranslationEntry) {
    if (key) {
      this.translations[key] = translation;
    }
  }

  getTranslation(key: string) {
    return this.translations[key] ?? "";
  }

  getTranslationEntry(key: string) {
    if (Object.prototype.hasOwnProperty.call(this.translations, key)) {
      return this.translations[key];
    }
    return "";
  }
}

const addDictionaryEntryTranslations = (data: any): Translations => {
  // Initialize translation dictionary
  const translations = Translations.getInstance();
  translations.addToDictionary("accessoryTabHeader", data.accessoryTabHeader);
  translations.addToDictionary("accessoryTabCallout", data.accessoryTabCallout);
  translations.addToDictionary("availabilityAlertBox", data.availabilityAlertBox);
  translations.addToDictionary("bleed", data.bleed);
  translations.addToDictionary("clearSelection", data.clearSelection);
  translations.addToDictionary("componentError", data.componentError);
  translations.addToDictionary("defaultCtaText", data.defaultCtaText);
  translations.addToDictionary("designServices", data.designServices);
  translations.addToDictionary("designServicesCTA", data.designServicesCTA);
  translations.addToDictionary("designServicesDescription", data.designServicesDescription);
  translations.addToDictionary("designServicesEyebrow", data.designServicesEyebrow);
  translations.addToDictionary("designServicesSubheader", data.designServicesSubheader);
  translations.addToDictionary("designServicesTitle", data.designServicesTitle);
  translations.addToDictionary("designSpecsInfo", data.designSpecsInfo);
  translations.addToDictionary("dimensionsTabHeader", data.dimensionsTabHeader);
  translations.addToDictionary("dismissAlert", data.dismissAlert);
  translations.addToDictionary("downloadTemplate", data.downloadTemplate);
  translations.addToDictionary("downloadTemplateInfo", data.downloadTemplateInfo);
  translations.addToDictionary("designInstructions", data.designInstructions);
  translations.addToDictionary("designInstructionsText", data.designInstructionsText);
  translations.addToDictionary("dropdownIncompatibleMessage", data.dropdownIncompatibleMessage);
  translations.addToDictionary("editorOptionsTabHeader", data.editorOptionsTabHeader);
  translations.addToDictionary("faqHeader", data.faqHeader);
  translations.addToDictionary("faqTabHeader", data.faqTabHeader);
  translations.addToDictionary("finishingOptionsTabHeader", data.finishingOptionsTabHeader);
  translations.addToDictionary(
    "finishingOptionsTabContentTitle",
    data.finishingOptionsTabContentTitle
  );
  translations.addToDictionary("fullRangedHelperText", data.fullRangedHelperText);
  translations.addToDictionary("heroDefaultAltText", data.heroDefaultAltText);
  translations.addToDictionary("heroThumbnailAltText", data.heroThumbnailAltText);
  translations.addToDictionary("heroReferentialImageAltText", data.heroReferentialImageAltText);
  translations.addToDictionary(
    "heroReferentialImageThumbnailAltText",
    data.heroReferentialImageThumbnailAltText
  );
  translations.addToDictionary("inputErrorAboveMaximum", data.inputErrorAboveMaximum);
  translations.addToDictionary("inputErrorBelowMinimum", data.inputErrorBelowMinimum);
  translations.addToDictionary("inputErrorBetweenRanges", data.inputErrorBetweenRanges);
  translations.addToDictionary("inputErrorGeneral", data.inputErrorGeneral);
  translations.addToDictionary("inputErrorNotANumber", data.inputErrorNotANumber);
  translations.addToDictionary("inputErrorPrecision", data.inputErrorPrecision);
  translations.addToDictionary("inputErrorRequiredField", data.inputErrorRequiredField);
  translations.addToDictionary("requiredInformationErrorToast", data.requiredInformationErrorToast);
  translations.addToDictionary("heroImageAltTextPrefix", data.heroImageAltTextPrefix);
  translations.addToDictionary("mailingListTemplateTabHeader", data.mailingListTemplateTabHeader);
  translations.addToDictionary("mailingServicesDescription", data.mailingServicesDescription);
  translations.addToDictionary("mailingServiceTabHeader", data.mailingServiceTabHeader);
  translations.addToDictionary(
    "mailingServiceTermsOfUseCallout",
    data.mailingServiceTermsOfUseCallout
  );
  translations.addToDictionary(
    "mailingServiceTermsOfUseContent",
    data.mailingServiceTermsOfUseContent
  );
  translations.addToDictionary("outOfStockBanner", data.outOfStockBanner);
  translations.addToDictionary("outOfStockButtonAttribute", data.outOfStockButtonAttribute);
  translations.addToDictionary("overviewTabHeader", data.overviewTabHeader);
  translations.addToDictionary("partialRangedHelperText", data.partialRangedHelperText);
  translations.addToDictionary("priceChartTabHeader", data.priceChartTabHeader);
  translations.addToDictionary("printedProductDesign", data.printedProductDesign);
  translations.addToDictionary("productSpecsTemplates", data.productSpecsTemplates);
  translations.addToDictionary("qty", data.qty);
  translations.addToDictionary("safe", data.safe);
  translations.addToDictionary("safeArea", data.safeArea);
  translations.addToDictionary("seeDesignServices", data.seeDesignServices);
  translations.addToDictionary("seeDetails", data.seeDetails);
  translations.addToDictionary(
    "shopWithYourDesignWarningMessage",
    data.shopWithYourDesignWarningMessage
  );
  translations.addToDictionary("sizeChartsTabHeader", data.sizeChartsTabHeader);
  translations.addToDictionary("specsAndTemplatesTabHeader", data.specsAndTemplatesTabHeader);
  translations.addToDictionary("trim", data.trim);
  translations.addToDictionary("vortexToggleView", data.vortexToggleView);
  translations.addToDictionary("vortexLoadError", data.vortexLoadError);
  translations.addToDictionary("vortexLoadingPreview", data.vortexLoadingPreview);
  translations.addToDictionary("vortexActionsFront", data.vortexActionsFront);
  translations.addToDictionary("vortexActionsBack", data.vortexActionsBack);
  translations.addToDictionary("vortexActionsFolded", data.vortexActionsFolded);
  translations.addToDictionary("vortexActionsUnfolded", data.vortexActionsUnfolded);
  translations.addToDictionary("vortexActionsOpen", data.vortexActionsOpen);
  translations.addToDictionary("vortexActionsClose", data.vortexActionsClose);
  translations.addToDictionary("specsAndTemplatesLink", data.specsAndTemplatesLink);
  translations.addToDictionary("tabsAriaLabel", data.tabsAriaLabel);
  translations.addToDictionary("heroGalleryAriaLabel", data.heroGalleryAriaLabel);
  translations.addToDictionary("heroThumbnailAriaLabel", data.heroThumbnailAriaLabel);
  translations.addToDictionary("heroImageAriaLabel", data.heroImageAriaLabel);

  return translations;
};

export { Translations, addDictionaryEntryTranslations };
